export class LoginResult {
}
//# sourceMappingURL=login-result.entity.js.map